import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useShop } from "../context/ShopContext";

const CatalogStrip = () => {
  const { t, lang, products, productMedia, cval } = useShop();
  const navigate = useNavigate();
  const s = t.strip;
  const list = products || [];
  const first = list[0];
  const second = list[3] || list[1] || list[0];

  return (
    <section
      className="py-24 md:py-36 px-6 md:px-12 max-w-[1440px] mx-auto"
      data-testid="catalog-strip"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs tracking-[0.3em] uppercase font-semibold text-olive-dark mb-4">
            {s.chapter}
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-brown">
            {cval(`strip_title_${lang}`, s.title)}
          </h2>
          <p className="mt-6 max-w-md text-base md:text-lg font-light leading-relaxed text-brown-light">
            {cval(`strip_text_${lang}`, s.text)}
          </p>
          <button
            onClick={() => navigate("/urunler")}
            className="group mt-10 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-brown text-cream text-sm font-medium tracking-wide hover:bg-olive-dark transition-colors duration-300"
            data-testid="catalog-strip-cta"
          >
            {s.cta}
            <ArrowRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="flex gap-5"
        >
          <div className="flex-1 overflow-hidden aspect-[3/4] bg-cream-dark">
            {first && (
              <img
                src={productMedia(first)}
                alt="VLP Dolap koleksiyonu"
                loading="lazy"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[800ms]"
              />
            )}
          </div>
          <div className="flex-1 overflow-hidden aspect-[3/4] bg-cream-dark translate-y-10">
            {second && (
              <img
                src={productMedia(second)}
                alt="VLP Dolap koleksiyonu"
                loading="lazy"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[800ms]"
              />
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CatalogStrip;
